import {
  GlobalCard,
  GlobalCardBody,
  GlobalCardHeader,
  GlobalCardHeaderTitle,
} from '@global-engineering-shared/gweb-material-lab';
import { Typography } from '@global-engineering-shared/gweb-material-ui';
import React, { useState } from 'react';

import { Toggle } from 'components/CheckboxToggle/types/Toggle';
import CheckboxToggleGroup from 'components/CheckboxToggleGroup';
import DateTimePicker from 'components/DateTimePicker';
import { Frame } from 'features/Frames/types';
import MonetisationHealthChartContainer from 'features/Health/containers/MonetisationHealthChartContainer';
import { initialMonetisationHealthToggleState } from 'features/Health/containers/MonetisationHealthChartContainer/utils/initialMonetisationHealthToggleState';

import useStyles from './MonetisationHealthContainer.styles';

type MonetisationHealthContainerProps = {
  frame?: Frame;
};

const MonetisationHealthContainer = ({ frame }: MonetisationHealthContainerProps) => {
  const classes = useStyles();
  const [toggles, setToggles] = useState<Toggle[]>(initialMonetisationHealthToggleState);

  const getTitleComponent = () => () =>
    (
      <div className={classes.title}>
        <Typography variant="h3" fontWeight={600}>
          Monetisation Health Metrics
        </Typography>
        <div className={classes.titleToggleAndDateContainer}>
          <CheckboxToggleGroup toggles={toggles} setToggles={setToggles} />
          <DateTimePicker />
        </div>
      </div>
    );

  return (
    <GlobalCard className={classes.root}>
      <GlobalCardHeader className={classes.header}>
        <GlobalCardHeaderTitle TitleComponent={getTitleComponent()} />
      </GlobalCardHeader>
      <GlobalCardBody className={classes.body}>
        <MonetisationHealthChartContainer toggles={toggles} frame={frame} />
      </GlobalCardBody>
    </GlobalCard>
  );
};

export default MonetisationHealthContainer;
